import { Injectable, Component } from '@angular/core';

import { Observable ,  Subject ,  BehaviorSubject } from 'rxjs';


@Injectable()
export class AppModalService {

  activeModal: any;
  private _openModal: BehaviorSubject<any>;

  constructor() {
    this._openModal = <BehaviorSubject<string>>new BehaviorSubject(null);
  }

  // getters
  get openModalListener() {
    return this._openModal.asObservable();
  }

  // Service commands
  showModal(modalName: string, inputData?: any, outputData?: any) {
    const modalData: any = {
      name: modalName,
    };
    if (inputData) { modalData.inputData = inputData; }
    if (outputData) { modalData.outputData = outputData; }
    this._openModal.next(modalData);
  }
}
